import { render } from "./AgentSelection.vue?vue&type=template&id=5edbc5f4"
import script from "./AgentSelection.vue?vue&type=script&lang=js"
export * from "./AgentSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__